import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import { Container } from "reactstrap";
import * as loadFile from "./loadFile.json";

function LoadingFile() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadFile.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     setTimeout(() => {
  //       setLoading(true);
  //     }, 3000);
  //   }, []);

  return (
    <React.Fragment>
      {/* {!loading ?  */}
      <FadeIn>
        <Lottie
          options={defaultOptions}
          width={200}
          height={150}
          // style={{
          //   position: "absolute",
          //   top: "40%",
          //   left: "25%",
          // }}
        />
      </FadeIn>
      {/* // : null} */}
    </React.Fragment>
  );
}

export default LoadingFile;
